export default __webpack_public_path__ + "static/media/carousel-item-04.fdc23fc0.jpg";